define(
    ['text!./templates/mfp-add-vehicle.html',
        'customerEdge/platform/base/JsonRPCException',
        'underscore'],
    (templateStr, JsonRPCException, _) => ['$filter', 'BaslerTypelistMappingService', '$stateParams', 'ModalService', 'BaslerVehicleSearchService',
        'ContextService', 'BaslerDateUtilService', 'MFPService',
        function ($filter, BaslerTypelistMappingService, $stateParams, ModalService, BaslerVehicleSearchService, ContextService, BaslerDateUtilService, MFPService) { // NOSONAR
            return {
                restrict: 'E',
                scope: {
                    vehicle: '=', //view model!
                    country: '@',
                    readonly: '=',
                },
                template: templateStr,
                controller: ['$scope', function ($scope) {

                    $scope.callGroups = 'searchVehicle';
                    $scope.canStartTyping = false;

                    function loadAllMappingsSuccessHandler() {
                        $scope.canStartTyping = true;
                    }

                    function loadAllMappingsErrorHandler(error) {
                        throw new JsonRPCException({cause: 'Cannot load BaslerTypelistMappings'}, error);
                    }

                    function showNoVehicleFound() {
                        ModalService.showInfo(
                            'quoteandbind.mfp.directives.templates.mfp-add-vehicle.NoUniqueVehicleFound.title',
                            'quoteandbind.mfp.directives.templates.mfp-add-vehicle.NoUniqueVehicleFound.message'
                        );
                    }

                    function setPresetFirstRefistrationDate() {
                        $scope.days = BaslerDateUtilService.getDays();
                        $scope.months = BaslerDateUtilService.getMonths();
                        $scope.vehicle.firstRegistration.value = BaslerVehicleSearchService.getPresetFirstRegistration();
                        $scope.selectedMonth = _.find($scope.months, {id: BaslerDateUtilService.getMonthAsNumber($scope.vehicle.firstRegistration.value)});
                        $scope.selectedYear = BaslerDateUtilService.getYear($scope.vehicle.firstRegistration.value);
                    }

                    //loads typelist translations for vehicle parts
                    BaslerTypelistMappingService.loadAllMappings()
                        .then(loadAllMappingsSuccessHandler, loadAllMappingsErrorHandler)
                        .then(() => {
                            if (BaslerVehicleSearchService.isPresetInformationAvailable()) {
                                BaslerVehicleSearchService.getPresetVehicle()
                                    .then((response) => {
                                        if (response && response.data && response.data.response && response.data.response.docs[0]) {
                                            $scope.onVehicleSelected(response.data.response.docs[0]);
                                            setPresetFirstRefistrationDate();
                                        } else {
                                            showNoVehicleFound();
                                        }
                                    }).catch(() => {
                                    showNoVehicleFound();
                                });
                            }
                        });

                    // In case vehicle is loaded from backend (has fixedId), it is considered as vehicleSelected=true
                    $scope.vehicleSelected = !_.isUndefined($scope.vehicle.fixedId.value);

                    // Configuration of the max and min date for the first registration date picker
                    const yearsToAddToMaxFirstRegistrationDate = 1;
                    const yearsToRestToMinFirstRegistrationDate = 40;
                    $scope.maxFirstRegistrationDate = new Date();
                    $scope.maxFirstRegistrationDate.setUTCFullYear($scope.maxFirstRegistrationDate.getUTCFullYear() + yearsToAddToMaxFirstRegistrationDate);
                    $scope.minFirstRegistrationDate = new Date();
                    $scope.minFirstRegistrationDate.setUTCFullYear($scope.minFirstRegistrationDate.getUTCFullYear() - yearsToRestToMinFirstRegistrationDate);

                    const getDisplayableVehicleTypeLine1 = function (vehicleType) {
                        let textKey = 'quoteandbind.mfp.directives.templates.mfp-add-vehicle.vehicleTypeaheadDescriptionLine1';
                        if (isMotorcycleMode()) {
                            textKey = 'quoteandbind.mfp.directives.templates.mfp-add-vehicle.motorcycleTypeaheadDescriptionLine1';
                        }

                        return $filter('translate')(
                            textKey,
                            {
                                makeName: vehicleType.markenName,
                                typeName: vehicleType.typName,
                                horsePower: vehicleType.ps,
                                kwPower: vehicleType.kw,
                                costNew: vehicleType.preis,
                            }
                        );
                    };

                    const getDisplayableVehicleTypeLine2 = function (vehicleType, vehicleWithAspects) {
                        let textKey = 'quoteandbind.mfp.directives.templates.mfp-add-vehicle.vehicleTypeaheadDescriptionLine2';
                        if (isMotorcycleMode()) {
                            textKey = 'quoteandbind.mfp.directives.templates.mfp-add-vehicle.motorcycleTypeaheadDescriptionLine2';
                        }
                        if (new Date(vehicleType.preisEnde).getYear() === 9999 - 1900) {
                            textKey = 'quoteandbind.mfp.directives.templates.mfp-add-vehicle.vehicleTypeaheadDescriptionLine2.noEnd';
                            if (isMotorcycleMode()) {
                                textKey = 'quoteandbind.mfp.directives.templates.mfp-add-vehicle.motorcycleTypeaheadDescriptionLine2.noEnd';
                            }
                        }

                        const translatedBodyType = _.findWhere(
                            vehicleWithAspects.bodyType.aspects.availableValues,
                            {code: BaslerTypelistMappingService.getBodyTypeByBaslerCode(vehicleType.karosserieart)}
                        ).name;
                        const translatedDriveType = _.findWhere(
                            vehicleWithAspects.driveType.aspects.availableValues,
                            {code: BaslerTypelistMappingService.getDriveTypeByBaslerCode(vehicleType.treibstoffart)}
                        ).name;
                        const translatedGearboxType = _.findWhere(
                            vehicleWithAspects.gearboxType.aspects.availableValues,
                            {code: BaslerTypelistMappingService.getGearboxTypeByBaslerCode(vehicleType.getriebeart)}
                        ).name;

                        return $filter('translate')(
                            textKey,
                            {
                                bodyType: translatedBodyType,
                                driveType: translatedDriveType,
                                gearboxType: translatedGearboxType,
                                doors: vehicleType.tueren,
                                totalWeight: vehicleType.gesamtGewicht,
                                typeCertificateNumber: vehicleType.typenscheinNummer,
                                fromDate: new Date(vehicleType.preisBeginn).toLocaleDateString(),
                                untilDate: new Date(vehicleType.preisEnde).toLocaleDateString(),
                                cubicCapacity: vehicleType.hubraum,
                                seats: vehicleType.anzahlPlaetze,
                            }
                        );
                    };

                    /**
                     * This function returns true if the user has to select the vehicle type manually
                     */
                    $scope.showVehicleTypeSelection = function () {
                        const typecertificateNumber = $scope.vehicle && $scope.vehicle.typeCertificateNumber && $scope.vehicle.typeCertificateNumber.value;
                        if (!typecertificateNumber) {
                            //if no 'typecertificateNumber', no need to display a choice
                            return false;
                        }
                        //in all the rest cases, check special condition...
                        const firstLetter = typecertificateNumber.charAt(0);
                        return firstLetter === '0' || firstLetter === 'Z';
                    };


                    /**
                     * This function returns true if the submission is not based on a leasing product
                     * if the submission is based on a leasing product, it returns false and it will default the isLeased propertie from the vehicle to true
                     */
                    $scope.showLeasingOption = function () {
                        const leasingProduct = ContextService.isPartnerLeasingProduct();
                        if (leasingProduct) {
                            $scope.vehicle.isLeased.value = true;
                        }
                        return !leasingProduct;
                    };

                    /**
                     * Parking overnight is only visible for Personal Auto vehicle types and non Partner products
                     */
                    $scope.showVehicleParkingOvernight = function () {
                        return MFPService.showParkingOverNight($scope.vehicle);
                    };

                    /**
                     * This function is called when the vehicle type has been changed
                     * The vehicle category has then to be set to the same value as the vehicle type
                     */
                    $scope.vehicleTypeSelected = (newValue) => {
                        $scope.vehicle.vehicleCategory.value = newValue;
                    };

                    /**
                     * This function is called from the typehead input. It looks for vehicles in the SOLR vehicle database
                     */
                    $scope.searchVehicles = function (userInput, vehicleWithAspects) {

                        const firstRegistrationDate = new Date($scope.vehicle.firstRegistration.value);


                        return BaslerVehicleSearchService.send(userInput, firstRegistrationDate, isMotorcycleMode(), $scope.callGroups)
                            .then(response => response.data.response.docs.map((doc) => {
                                doc.firstline = getDisplayableVehicleTypeLine1(doc);
                                doc.secondline = getDisplayableVehicleTypeLine2(doc, vehicleWithAspects);
                                return doc;
                            }), () => {
                                ModalService.showError(
                                    'platform.basler.DefaultErrorHandlerService.Retriable Error',
                                    'platform.basler.DefaultErrorHandlerService.Retriable Error.Please retry'
                                );
                                return [];
                            });

                    };

                    /**
                     * This function copy the value of the selected vehicle type into the vehicle.
                     * @Param {model) ModelLookupResponseDTO - Model selected in 'model' dropdown. Even when only the name is displayed, all the DTO is received as parameter
                     */
                    // next line ignores unused variables rule because it's a callback
                    $scope.onVehicleSelected = function (vehicleType) { // eslint-disable-line no-unused-vars
                        if (angular.isDefined(vehicleType) && vehicleType !== null) {
                            // Avoiding extra logic when the selected value is the already selected value
                            $scope.vehicle.value.copyValuesFromSolrVehicle(vehicleType, BaslerTypelistMappingService);
                            $scope.vehicleSelected = true;
                        }
                    }; // End of lookupVehicles

                    $scope.unselectVehicle = function () {
                        $scope.vehicleSelected = false;
                        $scope.vehicle.value.resetSorlValues();
                        $scope.vehicle.value.parkingOvernight = undefined;
                        $scope.vehicle.value.isLeased = undefined;
                    };

                    $scope.clearVehicleIfNecessary = function () {
                        // If no search string has been entered yet no clearing is necessary:
                        if (!$scope.vehicle.type.value) {
                            return;
                        }
                        const v = $scope.vehicle.value;
                        const firstRegistrationDate = new Date($scope.vehicle.firstRegistration.value);
                        BaslerVehicleSearchService.send(v.displayName, firstRegistrationDate, isMotorcycleMode(), $scope.callGroups)
                            .then((response) => {
                                const ids = response.data.response.docs.map(doc => doc.id);
                                const currentId = v.id;
                                // Clear selected vehicle if it is not available for the changed 'firstRegistrationDate':
                                if (!ids.includes(currentId)) {
                                    $scope.unselectVehicle();
                                    $scope.vehicle.type = undefined;
                                }
                            }, () => {
                                ModalService.showError(
                                    'platform.basler.DefaultErrorHandlerService.Retriable Error',
                                    'platform.basler.DefaultErrorHandlerService.Retriable Error.Please retry'
                                );
                            });
                    };

                    /**
                     * These functions return the localized vehicle string
                     */
                    $scope.vehicleDescriptionLine1 = function () {

                        if ($scope.vehicleSelected) {
                            const textKey = isMotorcycleMode() ?
                                'quoteandbind.mfp.directives.templates.mfp-add-vehicle.MotorcycleDescriptionLine1' :
                                'quoteandbind.mfp.directives.templates.mfp-add-vehicle.VehicleDescriptionLine1';

                            const params = {
                                make: $scope.vehicle.value.make,
                                typeName: $scope.vehicle.value.type,
                            };
                            return $filter('translate')(textKey, params);
                        }
                    };

                    $scope.vehicleDescriptionLine2 = function () {

                        if ($scope.vehicleSelected) {
                            const textKey = isMotorcycleMode() ?
                                'quoteandbind.mfp.directives.templates.mfp-add-vehicle.MotorcycleDescriptionLine2' :
                                'quoteandbind.mfp.directives.templates.mfp-add-vehicle.VehicleDescriptionLine2';

                            const params = {
                                gearboxType: $scope.vehicle.gearboxType.value ? `${$scope.vehicle.gearboxType.value.name}, ` : null,
                                horsePower: $scope.vehicle.value.horsePower,
                                bodyType: $scope.vehicle.bodyType.value ? $scope.vehicle.bodyType.value.name : null,
                                driveType: $scope.vehicle.driveType.value ? $scope.vehicle.driveType.value.name : null,
                                cubicCapacity: $scope.vehicle.value.cubicCapacity,
                                seats: $scope.vehicle.value.seats,

                            };
                            return $filter('translate')(textKey, params);
                        }
                    };

                    function isMotorcycleMode() {
                        //vehicle type can be provided as URL param or extracted from current vehicle
                        //URL params takes precedence
                        return ContextService.isMotorcycleMode();
                    }
                }],
            };
        }]
);



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/directives/MFPAddVehicle.js